import { toast } from 'react-toastify';
import { deleteInventoryReport, setInventoryReportById } from '../../../../sp-firebase/inventoryReportFB';
import { deleteFutureOrder } from '../../../../sp-firebase/futureOrderFB';
import { Material } from '../../../../sp-types';
import { IInventoryReportType } from '../../../../sp-types/InventoryReportType';
import { DEFAULT_COLOR } from '../../../../sp-types/InventoryType';
import React from 'react';

export const approveInventoryReports = async (inventoryReports: IInventoryReportType[], closeScreen: () => void) => {
  for (const item of inventoryReports) {
    if (item.id) {
      await setInventoryReportById(item.id, { ...item, status: 'completed' });
    }
  }
  closeScreen();
};

export const getTransactions = (
  reports: IInventoryReportType[] | undefined | null,
  colorDictionary: Record<string, string>,
  materialsMap: Record<string, Material>,
  materialId: string,
): MaterialTransaction[] =>
  reports
    ?.filter((report) => report.materialId === materialId)
    .map(
      ({ materialId, reportingTime, ...rest }, key): MaterialTransaction => ({
        ...rest,
        key,
        materialId,
        reportingTime,
        materialName: materialsMap[materialId]?.name,
        color: colorDictionary[materialId] || DEFAULT_COLOR,
      }),
    ) || [];

export const deleteRow = async (
  row: MaterialTransaction,
  refetch: () => void,
  setLoadingRows?: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
  setConfirmDelete?: (_row?: any) => void,
): Promise<void> => {
  setLoadingRows && setLoadingRows((prev) => ({ ...prev, [row.id || '']: true }));
  try {
    let result;

    // Check if this is a sales commitment (has uuid) or an inventory report
    if ('uuid' in row && row.uuid) {
      // Sales commitment - delete by UUID and accountId (to also delete exposure records)
      await deleteFutureOrder(row.uuid, row.accountId);
      result = true;
    } else {
      // Inventory report - delete by accountId, materialId, quantity, reportingTime
      result = await deleteInventoryReport(row.accountId, row.materialId, row.quantity, row.reportingTime as any);
    }

    setConfirmDelete?.(undefined);
    refetch();

    if (result) {
      toast.info('Deleted successfully');
    } else {
      toast.error('Error deleting report');
    }
  } catch (error) {
    console.error(error);
    toast.error('Error deleting report');
  }
  setLoadingRows?.((prev) => ({ ...prev, [row.id || '']: false }));
};
const editRow = (row: MaterialTransaction) => {};

export function formatCustomDate(date: Date): string {
  const optionsDate: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const optionsTime: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };

  return (
    date.toLocaleDateString('en-US', optionsDate).replace(',', '') + ' ' + date.toLocaleTimeString('en-US', optionsTime)
  );
}
export interface MaterialTransaction extends IInventoryReportType {
  key: number;
  materialName: string;
  color: string;
  uuid?: string;
}

export const sxRowsVisibleHover = {
  '& .action-buttons': { opacity: 0, pointerEvents: 'none', transition: 'opacity 120ms ease' },
  '& .MuiDataGrid-row:hover .action-buttons, & .MuiDataGrid-cell:focus-within .action-buttons, & .MuiDataGrid-row.Mui-selected .action-buttons':
    { opacity: 1, pointerEvents: 'auto' },
};
